"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var audio_1 = require("@syl-editor/lib/dist/lib/formats/audio");
var core_utilities_1 = require("@syl-editor/core-utilities");
var card_1 = require("../../card");
require("./style.css");
var Icon = function () { return (react_1.default.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
    react_1.default.createElement("g", { id: "toolbar/music", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        react_1.default.createElement("rect", { id: "\u77E9\u5F62", fill: "#000000", fillRule: "nonzero", opacity: "0", x: "0", y: "0", width: "24", height: "24" }),
        react_1.default.createElement("path", { d: "M5.5,20 C6.88071187,20 8,18.8807119 8,17.5 C8,16.1192881 6.88071187,15 5.5,15 C4.11928813,15 3,16.1192881 3,17.5 C3,18.8807119 4.11928813,20 5.5,20 Z", stroke: "#222222", strokeWidth: "1.5", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M16.5,19 C17.8807119,19 19,17.8807119 19,16.5 C19,15.1192881 17.8807119,14 16.5,14 C15.1192881,14 14,15.1192881 14,16.5 C14,17.8807119 15.1192881,19 16.5,19 Z", stroke: "#222222", strokeWidth: "1.5", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M8,17.5 L8,7", stroke: "#222222", strokeWidth: "1.5", strokeLinecap: "round" }),
        react_1.default.createElement("path", { d: "M19,16.5 L19,5", stroke: "#222222", strokeWidth: "1.5", strokeLinecap: "round" }),
        react_1.default.createElement("path", { d: "M8.82111456,5.85070644 L17.8211146,4.21434281 C18.3644909,4.11554711 18.8850742,4.47595093 18.9838699,5.01932728 C18.9946015,5.07835121 19,5.13822112 19,5.19821272 L19,8 L19,8 L8,10 L8,6.83457635 C8,6.35129021 8.34562387,5.9371593 8.82111456,5.85070644 Z", stroke: "#222222", strokeWidth: "1.5", strokeLinejoin: "round" })))); };
var renderTemplate = function (_a) {
    var _b = _a.attrs, src = _b.src, type = _b.type, title = _b.title, size = _b.size;
    return (react_1.default.createElement("div", { className: "syl-audio-wrapper" },
        react_1.default.createElement("audio", { title: title, "data-size": size, controls: true },
            react_1.default.createElement("source", { src: src, type: type }))));
};
var AudioSchema = /** @class */ (function (_super) {
    __extends(AudioSchema, _super);
    function AudioSchema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            template: renderTemplate,
            mask: renderTemplate
        };
        _this.renderer = _this.mount({ name: 'audio' });
        return _this;
    }
    return AudioSchema;
}(card_1.Card));
var AudioController = /** @class */ (function (_super) {
    __extends(AudioController, _super);
    function AudioController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.toolbar.icon = (react_1.default.createElement(Icon, null));
        return _this;
    }
    return AudioController;
}(audio_1.AudioController));
var AudioPlugin = /** @class */ (function (_super) {
    __extends(AudioPlugin, _super);
    function AudioPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'audio';
        _this.Controller = AudioController;
        return _this;
    }
    AudioPlugin.prototype.init = function (status, options) {
        this.Schema = core_utilities_1.configuration(audio_1.getAudioConfiguration(options.controllerProps))(AudioSchema);
        _super.prototype.init.call(this, status, options);
    };
    return AudioPlugin;
}(core_utilities_1.SylPlugin));
exports.AudioPlugin = AudioPlugin;
//# sourceMappingURL=index.js.map